// export default CourseLayout;
import VideoSection from './VideoSection';
import CourseDetails from './CourseDetails';
import CurriculumSidebar from './CurriculumSidebar';

const CourseLayout = ({
    course,
    activeVideo,
    activeLessonId,
    expandedSections,
    completionStatus,
    progressSummary,
    onVideoSelect,
    onToggleSection,
    onMarkComplete
}) => {
    return (
        <div className="course-content__layout">
            <div className="course-content__main">
                <div className="course-content__video">
                    <VideoSection
                        activeVideo={activeVideo}
                        completionStatus={completionStatus}
                        onMarkComplete={onMarkComplete}
                    />
                </div>
                <div className="course-content__sidebar">
                    <CurriculumSidebar
                        course={course}
                        expandedSections={expandedSections}
                        activeVideo={activeVideo}
                        completionStatus={completionStatus}
                        onVideoSelect={onVideoSelect}
                        onToggleSection={onToggleSection}
                        onMarkComplete={onMarkComplete}
                        progressSummary={progressSummary}
                    />
                </div>
                <div className="course-content__details">
                    <CourseDetails
                        course={course}
                        activeVideo={activeVideo}
                        activeLessonId={activeLessonId}
                    />
                </div>
            </div>


        </div>
    );
};

export default CourseLayout;